import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserCheckFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 1.25C6.37665 1.25 4.25 3.37665 4.25 6C4.25 8.62335 6.37665 10.75 9 10.75C11.6234 10.75 13.75 8.62335 13.75 6C13.75 3.37665 11.6234 1.25 9 1.25ZM1.25 18.95C1.25 15.802 3.80198 13.25 6.95 13.25H11.05C14.198 13.25 16.75 15.802 16.75 18.95C16.75 21.0487 15.0487 22.75 12.95 22.75H5.05C2.95132 22.75 1.25 21.0487 1.25 18.95ZM23.5303 8.53033C23.8232 8.23744 23.8232 7.76256 23.5303 7.46967C23.2374 7.17678 22.7626 7.17678 22.4697 7.46967L19 10.9393L17.5303 9.46967C17.2374 9.17678 16.7626 9.17678 16.4697 9.46967C16.1768 9.76256 16.1768 10.2374 16.4697 10.5303L18.4697 12.5303C18.7626 12.8232 19.2374 12.8232 19.5303 12.5303L23.5303 8.53033Z",
		fill: "#EFEEF0"
	})
});
export default SvgUserCheckFilled;
